<template>
  <el-drawer
    :title="$t('home.advancedSearch')"
    :visible.sync="searchDrawer"
    direction="ltr"
    size="600px"
  >
    <el-form label-position="top" size="small">
      <el-row
        :gutter="10"
        justify="left"
        style="flex-wrap: wrap; padding: 0 20px; box-sizing: border-box"
        type="flex"
      >
        <!-- 操作人州（与页面大区/网点联动） -->
        <el-col :span="12">
          <el-form-item :label="$t('GlobalSetObj.OperationState')">
            <el-select
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              :value="stateValue"
              clearable
              filterable
              multiple
              style="width: 100%"
              @change="handleStateChange"
            >
              <el-option
                v-for="item in stateOptions"
                :key="item.id"
                :label="item.label"
                :value="item.label"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 操作人 -->
        <el-col :span="12">
          <el-form-item :label="$t('GlobalSetObj.operator')">
            <el-select
              v-model.trim="localParams.operateUserName"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              :remote-method="getOperationName"
              clearable
              filterable
              remote
              reserve-keyword
              style="width: 100%"
              @clear="getOperationName"
            >
              <el-option
                v-for="(item, index) in localUserList"
                :key="index"
                :label="item.operateUserName"
                :value="item.keyId"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 运单号 -->
        <el-col :span="12">
          <el-form-item>
            <div class="selectLabel">
              <el-select v-model="localParams.selectType" style="width: 130px">
                <el-option key="1" :label="$t('newOrder.waybillNumber')" :value="1" />
                <el-option key="3" :label="$t('GlobalSetObj.ScanNumber')" :value="3" />
                <el-option key="2" :label="$t('GlobalSetObj.bagNumber')" :value="2" />
              </el-select>
            </div>
            <el-input
              v-model="localParams.inputValue"
              :placeholder="$t('newOrder.PreciseSearch1')"
              :rows="1"
              style="width: 100%"
              type="textarea"
            />
          </el-form-item>
        </el-col>
        <!-- 收件人州 -->
        <el-col :span="12">
          <el-form-item :label="$t('newOrder.RecipientState')">
            <el-select
              v-model="localParams.preDeliverySiteState"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              filterable
              multiple
              style="width: 100%"
              @change="handlepreDeliverySiteState"
            >
              <el-option
                v-for="item in stateOptions"
                :key="item.id"
                :label="item.label"
                :value="item.label"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 预派送网点 -->
        <el-col :span="12">
          <el-form-item :label="$t('GlobalSetObj.preEntrega')">
            <el-select
              v-model="localParams.preDeliverySiteId"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              filterable
              style="width: 100%"
            >
              <el-option
                v-for="item in preDeliverySiteList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 下一站 -->
        <el-col :span="12">
          <el-form-item :label="$t('GlobalSetObj.nextStation')">
            <el-select
              v-model="localParams.nextSiteIds"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              filterable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="item in siteList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 运单状态 -->
        <el-col :span="12">
          <el-form-item :label="$t('newOrder.waybillStatus')">
            <el-select
              v-model="localParams.waybillStatus"
              :placeholder="$t('GlobalSetObj.all')"
              clearable
              collapse-tags
              filterable
              multiple
              style="width: 100%"
              @change="selectStatus"
            >
              <el-option
                v-for="(item, ind) in waybillStatusList"
                :key="ind"
                :label="item.label"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 客户 -->
        <el-col :span="12">
          <el-form-item :label="$t('GlobalSetObj.client')">
            <QueryCustomerV2Cmp
              :multiple-limit="10"
              :val="localParams.customerIdList"
              multiple
              style="width: 100%"
              @change="handleCustomerChange"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="drawer-footer">
      <el-button size="small" @click="handleReset">{{ $t('newOrder.reset') }}</el-button>
      <el-button size="small" type="primary" @click="handleSearch">{{
        $t('newOrder.search')
      }}</el-button>
    </div>
  </el-drawer>
</template>

<script>
import { cloneDeep } from 'lodash-es';
import { selectInfoByStateTwo, selectSiteByState } from '@/api/orderApi';
import QueryCustomerV2Cmp from '@/views/finance/cmp/Query/QueryCustomerV2Cmp.vue';

const DEFAULT_PARAMS = {
  selectType: 1,
  inputValue: '',
  operateUserName: '',
  preDeliverySiteState: [],
  preDeliverySiteId: '',
  nextSiteIds: [],
  waybillStatus: [],
  customerIdList: []
};

export default {
  name: 'SearchCom',
  components: {
    QueryCustomerV2Cmp
  },
  props: {
    // 下一站网点选项
    siteList: {
      type: Array,
      default: () => []
    },
    // 当前大区下可选州（随页面大区联动）
    stateOptions: {
      type: Array,
      default: () => []
    },
    // 当前已选州（随页面大区联动）
    stateValue: {
      type: Array,
      default: () => []
    },
    waybillStatusList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchDrawer: false,
      localParams: cloneDeep(DEFAULT_PARAMS),
      localUserList: [],
      customerNameMap: {}, // 客户 id -> 名称映射（供父组件展示）
      preDeliverySiteList: []
    };
  },
  methods: {
    showDialog() {
      if (
        !this.localParams.preDeliverySiteState ||
        this.localParams.preDeliverySiteState.length === 0
      ) {
        this.preDeliverySiteList = [...this.siteList];
      }
      this.searchDrawer = true;
    },
    handleStateChange(val) {
      this.$emit('update:stateValue', val);
    },
    handleSearch() {
      this.$emit('search', {
        params: cloneDeep(this.localParams),
        userList: cloneDeep(this.localUserList),
        customerNameMap: { ...this.customerNameMap }
      });
      this.searchDrawer = false;
    },
    // 提供给父组件：获取当前选中的查询条件（未点搜索直接关闭也能生效）
    getLocalParams() {
      return {
        params: cloneDeep(this.localParams),
        userList: cloneDeep(this.localUserList),
        customerNameMap: { ...this.customerNameMap }
      };
    },
    handleReset() {
      this.localParams = cloneDeep(DEFAULT_PARAMS);
      this.localUserList = [];
      this.customerNameMap = {};
      this.preDeliverySiteList = [...this.siteList];
      // 操作人州为受控 props，需回传清空父组件
      this.$emit('update:stateValue', []);
    },
    // 收件人州联动预派送网点
    handlepreDeliverySiteState(val) {
      this.localParams.preDeliverySiteId = '';
      if (val && val.length > 0) {
        selectSiteByState(val).then((res) => {
          if (res.status === 'OK') {
            this.preDeliverySiteList = res.data;
          }
        });
      } else {
        this.preDeliverySiteList = [...this.siteList];
      }
    },
    // 操作人远程搜索
    getOperationName(val = '') {
      const data = {
        operateUserName: val
      };
      selectInfoByStateTwo(data).then((res) => {
        if (res.code === 200) {
          this.localUserList = res.data.userList;
        }
      });
    },
    selectStatus(val) {
      if (val.indexOf(0) !== -1) {
        this.localParams.waybillStatus = [
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22
        ];
      }
    },
    // 选择客户：id 用于搜索，名称用于展示
    handleCustomerChange(val) {
      this.localParams.customerIdList = val || [];
      this.buildCustomerNameMap(this.localParams.customerIdList);
    },
    buildCustomerNameMap(ids) {
      const list = this.getCustomerListCache();
      const map = {}
      ;(ids || []).forEach((id) => {
        const item = list.find((it) => it.value === id);
        map[id] = item ? item.label : id;
      });
      this.customerNameMap = map;
    },
    getCustomerListCache() {
      try {
        return JSON.parse(window.sessionStorage.getItem('QueryCustomerV2Cmp') || '[]');
      } catch (e) {
        return [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.selectLabel {
  display: flex;
  align-items: center;

  ::v-deep .el-input {
    height: 28px !important;
  }

  ::v-deep .el-input__inner {
    border: none;
    box-shadow: none;
    color: #606266;
    font-size: 14px;
    background: transparent;
    padding: 0;
    text-align: left;
  }

  ::v-deep .el-input__icon {
    line-height: 28px;
  }
}

.drawer-footer {
  display: flex;
  justify-content: flex-end;
  padding: 16px 20px;
}
</style>
